import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../../../shared/constants';

/**
 * Без фото — іконка камери.
 * З фото — превʼю (клік → повне фото) або іконка, якщо превʼю не завантажилось.
 */
const IncomingShipmentItemPhotoCell = ({
  item,
  uploading,
  onSelectFile,
  onDelete,
  placement = 'withBind'
}) => {
  const photoName = item?.photoAwsName;
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [photoName]);

  const thumbMax = placement === 'afterName' ? 26 : 36;
  /** Як у Basket, OrderItemDesktop, AdminOrderPage — повний URL через BASE_URL */
  const thumbPx = thumbMax * 2;
  const imgSrc = photoName
    ? `${BASE_URL}/api/v1/product/image/${photoName}?height=${thumbPx}&width=${thumbPx}`
    : null;
  const fullHref = photoName ? `${BASE_URL}/api/v1/product/image/${photoName}` : null;

  const fileInput = (
    <input
      type='file'
      accept='image/*'
      className='d-none'
      disabled={uploading}
      onChange={(e) => {
        const f = e.target.files && e.target.files[0];
        if (f) onSelectFile(f);
        e.target.value = '';
      }}
    />
  );

  const addPhotoLabel = (
    <label
      className={`mb-0 d-inline-flex align-items-center flex-shrink-0 ${uploading ? 'opacity-50' : 'text-secondary'}`}
      style={{ cursor: uploading ? 'wait' : 'pointer', lineHeight: 1 }}
      title='Додати фото'
      data-incoming-photo-area='true'
    >
      {uploading ? (
        <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' />
      ) : (
        <i className='bi bi-camera' style={{ fontSize: placement === 'afterName' ? '1.05rem' : '1.2rem' }} />
      )}
      {fileInput}
    </label>
  );

  const boxSize = thumbMax + 6;
  const previewBoxStyle = {
    width: boxSize,
    minWidth: boxSize,
    height: boxSize,
    minHeight: boxSize,
    flexShrink: 0,
    boxSizing: 'border-box'
  };

  const photoPreviewLink = photoName && imgSrc ? (
    uploading ? (
      <span
        className='d-inline-flex align-items-center justify-content-center border rounded bg-light flex-shrink-0'
        style={previewBoxStyle}
        title='Завантаження…'
        data-incoming-photo-area='true'
      >
        <span className='spinner-border spinner-border-sm text-secondary' role='status' aria-hidden='true' />
      </span>
    ) : (
      <a
        href={fullHref}
        target='_blank'
        rel='noopener noreferrer'
        title='Переглянути фото'
        className='d-inline-flex align-items-center justify-content-center border rounded overflow-hidden bg-light text-decoration-none incoming-receipt-photo-preview flex-shrink-0'
        style={previewBoxStyle}
        data-incoming-photo-area='true'
      >
        {imgError ? (
          <i className='bi bi-image text-secondary' style={{ fontSize: '1.1rem' }} aria-hidden='true' />
        ) : (
          <img
            className='img-fluid'
            src={imgSrc}
            alt=''
            onError={() => setImgError(true)}
            style={{
              maxWidth: thumbMax,
              maxHeight: thumbMax,
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              display: 'block'
            }}
          />
        )}
      </a>
    )
  ) : null;

  const replacePhotoLabel = photoName ? (
    <label
      className={`mb-0 d-inline-flex align-items-center flex-shrink-0 ${uploading ? 'opacity-50' : 'text-secondary'}`}
      style={{ cursor: uploading ? 'not-allowed' : 'pointer', lineHeight: 1 }}
      title='Замінити фото'
      data-incoming-photo-area='true'
    >
      <i className='bi bi-camera' style={{ fontSize: placement === 'afterName' ? '0.95rem' : '1.05rem' }} />
      {fileInput}
    </label>
  ) : null;

  const deleteBtn = photoName ? (
    <button
      type='button'
      className='btn btn-link text-danger p-0 border-0 d-inline-flex align-items-center flex-shrink-0'
      style={{ lineHeight: 1, fontSize: placement === 'afterName' ? '0.95rem' : '1.05rem' }}
      disabled={uploading}
      title='Видалити фото'
      onClick={onDelete}
      data-incoming-photo-area='true'
    >
      <i className='bi bi-trash' />
    </button>
  ) : null;

  const inner = photoName ? (
    <>
      {photoPreviewLink}
      {!uploading ? replacePhotoLabel : null}
      {deleteBtn}
    </>
  ) : (
    addPhotoLabel
  );

  const rowClass = 'd-inline-flex align-items-center flex-nowrap flex-shrink-0';
  const rowStyle = { gap: '0.35rem' };

  if (placement === 'afterName') {
    return (
      <span data-incoming-photo-area='true' className={rowClass} style={rowStyle}>
        {inner}
      </span>
    );
  }

  return (
    <div data-incoming-photo-area='true' className={rowClass} style={rowStyle}>
      {inner}
    </div>
  );
};

export default IncomingShipmentItemPhotoCell;

